import { Component, OnInit } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Spinkit } from 'ng-http-loader';
import { BottomSheetCategory } from '../food-menu';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-sample-menu',
  templateUrl: './sample-menu.component.html',
  styleUrls: ['./sample-menu.component.scss']
})
export class SampleMenuComponent implements OnInit {
  public spinkit = Spinkit;
  constructor(
    private _snackBar: MatSnackBar,
    private _bottomSheet: MatBottomSheet,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      const payload = params['payload'];


      console.log(payload);
      if (payload) {
        try {
          // 2. Decode base64
          const decodedJson = atob(payload);

          // 3. Parse JSON
          const data = JSON.parse(decodedJson);

          console.log("Decoded Payload:", data);

          this.restoId = data.restaurant_id;
          this.restoName = data.name;
          this.restoLogo = data.logo;
        } catch (e) {
          console.error("Invalid payload:", e);
        }
      } else {
        console.warn("No payload found in the URL.");
      }
    });
  }
  restoId: any
  restoName: any = 'Sample Restaurant';
  restoLogo: any = null;

  showMessage() {
    this._snackBar.open('This is a sample menu. Actions will work only in the live menu.')
    setTimeout(() => {
      this._snackBar.dismiss()
    }, 2000)
  }

  uniqueCategories = [
    'Sample Starters',
    'Sample Mains',
    'Sample Sides'
  ]

  menuClick() {
    // const data = {
    //   foodDishOption: this.showndata,
    // }
    let sheetRef = this._bottomSheet.open(BottomSheetCategory, {
      data: this.uniqueCategories,
    });

    sheetRef.afterDismissed().subscribe((dataFromChild) => {
      console.log(dataFromChild)
      // this.Startervalue = dataFromChild;
      // let dishessss = this.filteredFoodDishType.map((item: any) => {
      //   return item.dish_type_name
      // }).sort()

      // if (this.Startervalue == 'All') {
      //   const ele = document.getElementById('id_' + dishessss[0])
      //   ele.scrollIntoView()
      // } else {
      //   const ele = document.getElementById('id_' + this.Startervalue)
      //   ele.scrollIntoView()
      // }

    });
  }






































  newItems = [
    {
      key: 'Sample Starters',
      value: [
        {
          name: "Sample Paneer Tikka",
          id: "S-1001",
          dish_type_name: "Starter",
          description: "Sample dish: Grilled cottage cheese cubes marinated in spices. For display only.",
          ingredients: "Paneer, spices, yogurt",
          price: "5.0",
          epos_product_id: null,
          spice_rating: "2",
          menu_names_id: "S-1",
          calories: "200",
          addOnExists: false,
          optionsExists: false,
          dish_option: [],
          dish_allergens: [
            {
              food_dishes_alergy_food_dish_id: "S-1001",
              allergens_name: "Milk",
              allergens_id: "8"
            }
          ],
          dish_allergen_options: [],
          canEat: 'Yes',
          dish_dietary_preferences: [
            {
              diet_preference_id: "1",
              diet_preference_name: "Vegetarian"
            }
          ],
          dish_dietary_preferences_option: [],
          dpAvailable: null,
          overallRating: 4.5,
          topChoice: 'Yes',
        },
        {
          name: "Sample Vegetable Spring Rolls",
          id: "S-1002",
          dish_type_name: "Starter",
          description: "Sample only: Crispy spring rolls with mixed veg. Not served.",
          ingredients: "Cabbage, carrot, flour wrap",
          price: "4.2",
          spice_rating: "1",
          menu_names_id: "S-1",
          dish_allergens: [],
          dish_allergen_options: [],
          dish_dietary_preferences: [
            {
              diet_preference_id: "1",
              diet_preference_name: "Vegetarian"
            }
          ],
          addOnExists: false,
          optionsExists: false,
          dish_option: [],
          overallRating: 3.8
        }
      ]
    },
    {
      key: 'Sample Mains',
      value: [
        {
          name: "Sample Butter Chicken",
          id: "S-2001",
          dish_type_name: "Main",
          description: "Sample placeholder: Creamy butter chicken, shown for reference.",
          ingredients: "Chicken, tomato, cream",
          price: "10.5",
          spice_rating: "2",
          dish_allergens: [
            {
              food_dishes_alergy_food_dish_id: "S-2001",
              allergens_name: "Milk",
              allergens_id: "8"
            }
          ],
          dish_dietary_preferences: [
            {
              diet_preference_id: "2",
              diet_preference_name: "Non-Vegetarian"
            }
          ],
          addOnExists: false,
          optionsExists: false,
          dish_option: [],
          overallRating: 4.3
        },
        {
          name: "Sample Palak Paneer",
          id: "S-2002",
          dish_type_name: "Main",
          description: "Reference item: Cottage cheese cubes in spinach gravy.",
          ingredients: "Spinach, paneer, spices",
          price: "8.9",
          spice_rating: "1",
          dish_allergens: [
            {
              food_dishes_alergy_food_dish_id: "S-2002",
              allergens_name: "Milk",
              allergens_id: "8"
            }
          ],
          dish_dietary_preferences: [
            {
              diet_preference_id: "1",
              diet_preference_name: "Vegetarian"
            }
          ],
          addOnExists: false,
          optionsExists: false,
          dish_option: [],
          overallRating: 4.1
        },
        {
          name: "Sample Chana Masala",
          id: "S-2003",
          dish_type_name: "Main",
          description: "For illustration: Spicy chickpea curry.",
          ingredients: "Chickpeas, onion, tomato",
          price: "7.5",
          spice_rating: "3",
          dish_allergens: [],
          dish_dietary_preferences: [
            {
              diet_preference_id: "1",
              diet_preference_name: "Vegetarian"
            }
          ],
          addOnExists: false,
          optionsExists: false,
          dish_option: [],
          overallRating: 4.0
        },
        {
          name: "Sample Egg Curry",
          id: "S-2004",
          dish_type_name: "Main",
          description: "Demo item: Boiled eggs in spicy tomato gravy.",
          ingredients: "Eggs, spices, tomato",
          price: "6.9",
          spice_rating: "2",
          dish_allergens: [],
          dish_dietary_preferences: [
            {
              diet_preference_id: "3",
              diet_preference_name: "Eggetarian"
            }
          ],
          addOnExists: false,
          optionsExists: false,
          dish_option: [],
          overallRating: 3.9,
          canEat: 'No',
        },
        {
          name: "Sample Fish Curry",
          id: "S-2005",
          dish_type_name: "Main",
          description: "Placeholder: Fish in coastal-style curry.",
          ingredients: "Fish, coconut, spices",
          price: "11.2",
          spice_rating: "3",
          dish_allergens: [
            {
              food_dishes_alergy_food_dish_id: "S-2005",
              allergens_name: "Fish",
              allergens_id: "4"
            }
          ],
          dish_dietary_preferences: [
            {
              diet_preference_id: "2",
              diet_preference_name: "Non-Vegetarian"
            }
          ],
          addOnExists: false,
          optionsExists: false,
          dish_option: [],
          overallRating: 4.2,
          canEat: 'No',
        }
      ]
    },
    {
      key: 'Sample Sides',
      value: [
        {
          name: "Sample Plain Naan",
          id: "S-3001",
          dish_type_name: "Side",
          description: "Dummy data: Indian flatbread.",
          ingredients: "Wheat flour, salt",
          price: "2.0",
          dish_allergens: [],
          dish_dietary_preferences: [
            {
              diet_preference_id: "1",
              diet_preference_name: "Vegetarian"
            }
          ],
          addOnExists: false,
          optionsExists: false,
          dish_option: [],
          overallRating: 3.5
        },
        {
          name: "Sample Jeera Rice",
          id: "S-3002",
          dish_type_name: "Side",
          description: "Mock data: Basmati rice with cumin.",
          ingredients: "Rice, cumin",
          price: "3.0",
          dish_allergens: [],
          dish_dietary_preferences: [
            {
              diet_preference_id: "1",
              diet_preference_name: "Vegetarian"
            }
          ],
          addOnExists: false,
          optionsExists: false,
          dish_option: [],
          overallRating: 3.8
        }
      ]
    }
  ];


}
